// extracted by mini-css-extract-plugin
export var copyableField = "_si-4";
export var customerBadge = "_si-0";
export var customerInfoTitle = "_si-2";
export var details = "_si-1";
export var dropdownContainer = "_si-5";
export var dropdownImage = "_si-6";
export var editAssigneeForm = "_si-a";
export var editButton = "_si-3";
export var email = "_si-7";
export var hidden = "_si-d";
export var input = "_si-8";
export var saveButton = "_si-b";
export var shopifyIcon = "_si-c";
export var suggestionBadge = "_si-e";
export var suggestionText = "_si-f";
export var username = "_si-9";